import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type OpportunityReferenceCategory =
  | 'durations'
  | 'responsibilities'
  | 'interpersonal-skills'
  | 'behavioral-skills';

export interface OpportunityReferenceValue {
  id: number;
  label: string;
}

@Injectable({ providedIn: 'root' })
export class OpportunityReferenceDataService {
  private readonly defaultUrl = `${environment.apiUrl}/reference-data`;

  constructor(private http: HttpClient) {}

  getByCategory(category: OpportunityReferenceCategory): Observable<OpportunityReferenceValue[]> {
    return this.http.get<OpportunityReferenceValue[]>(`${this.defaultUrl}/${category}`);
  }

  create(category: OpportunityReferenceCategory, label: string): Observable<OpportunityReferenceValue> {
    return this.http.post<OpportunityReferenceValue>(`${this.defaultUrl}/${category}`, { label });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.defaultUrl}/${id}`);
  }
}
